import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchOrderMaster } from 'actions/orderAggregators/purchase';
import { fetchAddress } from 'actions/common/address';
import { push } from 'connected-react-router';
import Purchase from 'components/OrderAggregators/Purchase';
import { showAlert } from 'actions/common/alert';

const mapStateToProps = ({ orderAggregatorsPurchase }) => ({
  ...orderAggregatorsPurchase
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchOrderMaster,
      fetchAddress,
      push,
      showAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Purchase);



// WEBPACK FOOTER //
// ./src/containers/OrderAggregators/Purchase/index.js